<div class="card">
	<div class="card-body">
		<div class="row mt-1">
			<div class="col">
				<div class="row justify-content-center">
					<div class="col-md-auto">
						<h3 class="text-bold">{{ caltitle | titlecase }}</h3>
					</div>
				</div>
			</div>
			<div class="col-md-auto">
				<div class="row justify-content-end">
					<div class="col-md-auto">
						<div class="btn-inline">
							<button
								type="button"
								class="btn btn-primary mr-2"
								(click)="today()">
								Oggi
							</button>
							<div
								class="btn-group"
								role="group">
								<button
									type="button"
									class="btn btn-primary py-2"
									(click)="prev()">
									<i class="fas fa-caret-left fa-lg"></i>
								</button>
								<button
									type="button"
									class="btn btn-primary py-2"
									(click)="next()">
									<i class="fas fa-caret-right fa-lg"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-1">
			<div
				id="calendar"
				[ngStyle]="{'height': height}"></div>
		</div>

	</div>
</div>
